import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_inventory",
  "use": "icon-icon_inventory-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 15 15\" id=\"icon-icon_inventory\"><path fill=\"#8C8C8C\" fill-rule=\"evenodd\" d=\"M3.902 2.46a.5.5 0 0 0-.409.213L1.938 4.879a.5.5 0 0 0-.091.288v7.294a.5.5 0 0 0 .5.5h9.617a.5.5 0 0 0 .5-.5V4.997a.5.5 0 0 0-.103-.303l-1.555-2.037a.5.5 0 0 0-.397-.196zm-.68 2.334.94-1.333h6l1.018 1.333zm-.375 1v6.167h8.617V5.794zm1.398 2H7.55v-1H4.245z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol